import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useId } from 'react';

import Icon from '../../../../app/shared/components/Icon/Icon';
import { ProductSelectionPanelTranslation } from '../../../localization/ModuleTranslation';
import Button from '../../../ui/Button/Button';
import ProductSelectionState from '../ProductSelectionState';
import css from './ProductSelectionPanel.css';

interface ProductSelectionPanelProps {
  selection: ProductSelectionState;
  translation: ProductSelectionPanelTranslation;
  children?: React.ReactNode;
  className?: string;
}

const ProductSelectionPanel = observer(
  ({ children, className, selection, translation }: ProductSelectionPanelProps) => {
    const countId = useId();

    if (!selection.hasSelection) {
      return null;
    }

    return (
      <div className={classNames(css.root, className)}>
        <p id={countId} role="status" aria-atomic className={css.count}>
          {translation.selectedCountFormat.interpolate([['count', String(selection.selectedCount)]])}
        </p>
        <div className={css.actions} role="group" aria-labelledby={countId}>
          {children}
        </div>
        <Button theme="secondary" variant="ghost" onClick={selection.clear}>
          <Icon name="cross" /> {translation.clearSelection}
        </Button>
      </div>
    );
  },
);

export default ProductSelectionPanel;
